import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../../context/Modal';
import { useUserStrategies } from '../../../context/UserStrategies';
import {
  CLONE_STRATEGY_ASSET,
  DELETE_STRATEGY_ASSETS,
} from '../../../http/apollo-queries';
import { FooterNavigator } from '../../Footer/FooterNavigator';

export const DuplicateAssetModal = ({
  strategyAssetId,
}: {
  strategyAssetId: string;
}) => {
  const { t } = useTranslation();
  const { closeModal } = useModalContext();
  const { refetch: refetchStrategies, loading: loadingStrategies } =
    useUserStrategies();

  const [cloneStrategyAsset, { loading: loadingCloneStrategyAsset }] =
    useMutation(CLONE_STRATEGY_ASSET);

  const title = t(`modals.duplicateAsset.title`);
  const subtitle = t('modals.duplicateAsset.subtitle');

  const onSave = () => {
    cloneStrategyAsset({
      variables: {
        strategyAssetId,
      },
    }).then(() => refetchStrategies().then(() => closeModal()));
  };

  return (
    <div className="flex flex-col gap-3 my-20 dark:bg-grey-90 dark:text-white">
      <div
        className={`
        w-4/5
        mx-auto
        font-medium
        text-center
        text-xl
      `}
      >
        {title}
      </div>

      <div className="text-grey-50 text-center">{subtitle}</div>

      <FooterNavigator
        loading={loadingCloneStrategyAsset || loadingStrategies}
        saveButtonName="Duplicate"
        saveButtonVariant={`primary`}
        onCancel={closeModal}
        onSave={onSave}
      />
    </div>
  );
};
